import Vue from "vue";
import { formatMoney, formatPhone, dateUnixLiteral } from "@/utils/helpers";

Vue.filter("formatMoney", formatMoney);
Vue.filter("formatPhone", formatPhone);
Vue.filter("dateUnixLiteral", dateUnixLiteral);
